module.exports = __webpack_public_path__ + "files/e546614f2b789fd6fb946fd507266129.png";